export const COMPLIANCE_RESULT = {
  PASS: 'PASS',
  FAIL: 'FAIL',
  INCONCLUSIVE: 'INCONCLUSIVE',
};

// DEPRECATED: remove dependence on `TRUST` value and use the global risk levels
// in constants/riskLevels.js instead
export const RISK_LEVEL = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  TRUST: 'TRUST',
};

export const RUN_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
};

export const VERIFICATION_RESULT = {
  LOW_RISK: 'LOW_RISK',
  HIGH_RISK: 'HIGH_RISK',
  INCONCLUSIVE: 'INCONCLUSIVE',
};

export const VERIFICATION_RESULT_SORT_ORDER = {
  LOW_RISK: 3,
  HIGH_RISK: 1,
  INCONCLUSIVE: 2,
  // fraud
  LOW: 7,
  MEDIUM: 6,
  HIGH: 5,
  TRUST: 8,
  // checks
  Passed: 10,
  Failed: 9,
};

export const CONFIDENCE = {
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
};

export const ANALYST_GROUPS = {
  FRAUD: 'FRAUD',
  RISKS: 'RISKS',
  REQUIREMENTS: 'REQUIREMENTS',
  VERIFICATIONS: 'LEGACY_VERIFICATIONS',
};
